/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Sunday, March 13th 2022, 7:09:57 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { FormControl, FormControlLabel, FormControlLabelProps } from "@mui/material";
import Switch, { SwitchProps } from "@mui/material/Switch";
import { OSFormInputProps, useControlledInput } from "ui-widgets/forms";
import {
  APIFormInputErrorWrapper,
  CustomInputValidationErrorWrapper,
  HelperTextInputWrapper,
} from "ui-widgets/forms/FormInputWrappers";

type SwitchFormInputProps<T> = Omit<OSFormInputProps<T>, "control"> &
  SwitchProps &
  Omit<FormControlLabelProps, "control">;

export const SwitchFormInput = <T,>(props: SwitchFormInputProps<T>) => {
  const {
    controlledProps,
    field: { onChange, value },
  } = useControlledInput<T>(props);

  return (
    <APIFormInputErrorWrapper schema_field_key={props.schema_field_key} label={props.label}>
      <CustomInputValidationErrorWrapper schema_field_key={props.schema_field_key} label={props.label}>
        <HelperTextInputWrapper helperText={props.helperText}>
          <FormControl>
            <FormControlLabel
              control={<Switch {...controlledProps} onChange={onChange} checked={value as boolean} {...props} />}
              {...props}
            />
          </FormControl>
        </HelperTextInputWrapper>
      </CustomInputValidationErrorWrapper>
    </APIFormInputErrorWrapper>
  );
};
